import { computed, defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { /*ActivityAction,*/ ActivityGetter } from '@/store/activity/activity.module';
import { ActivityMessageSchema } from '@/store/activity/activity.validator';
// import { Activity } from '@/store/activity/activity.model';
// import { Province } from '@/store/province/province.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
  name: 'ActivityMessageComponent',
  components: {
    BaseModalComponent,
    Multiselect,
  },
  props: {
    activityId: {
      type: Number
    }
  },
  setup: (props) => {
    const store = useStore();
    // const activity = computed<Activity | undefined>(() => store.getters[ActivityGetter.BY_ID](props.activityId));
    // const provinces = computed<Province[] | undefined>(() => activity.value?.provinces);
    const activityMessageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const userOptions = [
      { value: 1, label: 'tungman' },
      { value: 2, label: 'mawmaw' },
      { value: 3, label: 'xxx' }
    ];

    // form
    interface Form {
      id?: number | null;
      userIds?: string[] | null;
      content?: string;
    }
    const formData = reactive<Form>({
      id: props.activityId,
      userIds: [],
      content: '',
    });
    const validator = computed(() => ActivityMessageSchema.validate(formData, { abortEarly: false }));
    const errors = reactive({
      userIds: computed(() => validator.value.error?.details.some((detail) => detail.path[0] === 'userIds')),
      content: computed(() => validator.value.error?.details.some((detail) => detail.path[0] === 'content')),
    });
    // const isValid = computed(() => !errors.userIds && !errors.content);
    const isLoading = computed<boolean>(() => store.getters[ActivityGetter.STATUS] === 'init' || store.getters[ActivityGetter.STATUS] === 'loading');
    const submited = ref(false);

    // show modal
    const show = () => {
      activityMessageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      activityMessageModal.value?.hide();
    };

    // clear submit status
    const unsubmit = () => {
      submited.value = false;
    };

    // clear form
    const clearForm = () => {
      unsubmit();
    };

    // submit form
    const submitClick = () => {
      submited.value = true;
    };

    return {
      activityMessageModal,
      formData,
      errors,
      submited,
      isLoading,
      userOptions,
      show,
      hide,
      clearForm,
      submitClick,
      unsubmit,
    };
  }
});
